/**
 * Calendar
 */
import {
    Component, EventEmitter,
    Input,
    OnChanges, Output,
} from '@angular/core';

import { IDateFieldSpecs } from '../interfaces/field-specs';
import { ILocale } from '../date/config/locale';

export interface ICalendarAdditionnalStyle {
    datePickerLeft?: string;
    datePickerRight?: string;
}

@Component({
    selector: 'calendar',
    template: `
        <div *ngIf="fieldConfig" [formGroup]="fieldConfig.formGroup">
            <p-calendar [formControlName]="fieldConfig.formControlName"
                        [dateFormat]="dateFormat"
                        [yearRange]="yearRange"
                        [minDate]="fieldConfig.minDate"
                        [maxDate]="fieldConfig.maxDate"
                        [locale]="locale"
                        [tabindex]="tabindex"
                        [yearNavigator]="yearNavigator"
                        [monthNavigator]="monthNavigator"></p-calendar>
        </div>
    `,
    styleUrls: ["./calendar.component.scss"]
})
export class CalendarComponent implements OnChanges {

    @Input()
    public fieldConfig: IDateFieldSpecs;
    @Input()
    public onlyOneMonth: boolean = false;
    @Input()
    public disabled: boolean = false;
    @Input()
    public alignRightDatePicker: boolean = false;
    @Input()
    public isFull: boolean;
    @Input()
    public isPositionFixed: boolean = false;
    @Input()
    public monthNavigator: boolean = true;
    @Input()
    public tabindex: number;
    @Input()
    public dateFormat: string;
    @Input()
    public yearRange: string;
    @Input()
    public yearNavigator: boolean = false;
    @Input()
    public selectOtherMonths: boolean = false;
    @Input()
    public locale: ILocale;
    @Input()
    public hideOnDateTimeSelect: boolean = false;

    // TODO NG UPGRADE
    // je mets ici les @input et @output nécessaire pour garder la rétrocompatibilité
    @Input()
    public past: boolean;
    @Input()
    public minDate: string;
    @Input()
    public maxDate: string;
    @Input()
    public defaultDate: string;
    @Input()
    public placeholder: string;
    @Input()
    public appendTo: string;
    @Output()
    public onBlur: EventEmitter<null> = new EventEmitter<null>();
    @Output()
    public onFocus: EventEmitter<null> = new EventEmitter<null>();
    @Output()
    public onSelect: EventEmitter<null> = new EventEmitter<null>();

    public ngOnChanges(): void {
    }

}
